import { ChangeEvent, ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { InputCheckboxProps } from './input-checkbox.type';

export const InputCheckbox = forwardRef(
  (
    {
      name,
      value,
      disabled,
      label,
      rounded,
      secondaryLabel,
      strikeThrough,
      onChange,
      isIndeterminated,
      ...props
    }: InputCheckboxProps,

    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      if (!disabled) {
        onChange?.(e.currentTarget.checked);
      }
    };
    return (
      <div className='flex items-center'>
        <input
          ref={ref}
          checked={value}
          id={name}
          name={name}
          disabled={disabled}
          type='checkbox'
          className={classNames('h-4 w-4 border', {
            'rounded-xs': !rounded,
            'rounded-full': rounded,
            'indeterminate:fill-dark indeterminate:text-negative': isIndeterminated,
          })}
          onChange={handleChange}
          {...props}
        />
        {label && (
          <label
            htmlFor={name}
            className={classNames('ml-3', {
              'text-subtitle-s md:text-subtitle-m @md:text-subtitle-s': value,
              'text-body-s md:text-body-m @md:text-body-s': !value,
              'line-through': disabled && strikeThrough,
              'text-secondary cursor-pointer': !disabled,
              'text-soft': disabled,
            })}>
            {label}
          </label>
        )}
        {secondaryLabel && (
          <span
            className={classNames('pl-2', {
              'text-subtitle-xs md:text-subtitle-s @md:text-subtitle-xs': value,
              'text-body-xs md:text-body-s @md:text-body-xs': !value,
              'line-through': disabled && strikeThrough,
              'text-secondary': !disabled,
              'text-soft': disabled,
            })}>
            {secondaryLabel}
          </span>
        )}
      </div>
    );
  }
);
